<div fxLayou="row" fxLayoutAlign="center center" class="network" *ngIf="disconnected">
	<svg>
		<path
			  d="M7.73,10L15.73,18H6A4,4 0 0,1 2,14A4,4 0 0,1 6,10M3,5.27L5.75,8C2.56,8.15 0,10.77 0,14A6,6 0 0,0 6,20H17.73L19.73,22L21,20.73L4.27,4M19.35,10.03C18.67,6.59 15.64,4 12,4C10.5,4 9.15,4.43 8,5.17L9.45,6.63C10.21,6.23 11.08,6 12,6A5.5,5.5 0 0,1 17.5,11.5V12H19A3,3 0 0,1 22,15C22,16.13 21.36,17.11 20.44,17.62L21.89,19.07C23.16,18.16 24,16.68 24,15C24,12.36 21.95,10.22 19.35,10.03Z" />
	</svg>
	{{'No Internet Connection' | translate}}
</div>
<ion-app>
	<ion-router-outlet [swipeGesture]="false">
	</ion-router-outlet>
</ion-app>
<ion-spinner *ngIf="requesting" name="crescent"></ion-spinner>
<ion-progress-bar *ngIf="requestingUnreadMgs || requestingCompanies" type="indeterminate"></ion-progress-bar>
<ng-container *ngIf="!production">
	<div class="in_development">
		<!-- Dev. -->
	</div>
</ng-container>
<app-toast-animated></app-toast-animated>